import { render, staticRenderFns } from "./TrustedSenders.vue?vue&type=template&id=0cf1c097&scoped=true"
import script from "./TrustedSenders.vue?vue&type=script&lang=js"
export * from "./TrustedSenders.vue?vue&type=script&lang=js"
import style0 from "./TrustedSenders.vue?vue&type=style&index=0&id=0cf1c097&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf1c097",
  null
  
)

export default component.exports